module.exports = __webpack_public_path__ + "static/media/compalince.df396259.png";